import script from './form.vue_vue_type_script_lang.mjs';
export { default } from './form.vue_vue_type_script_lang.mjs';
import { render } from './form.vue_vue_type_template_id_602d6cf6_lang.mjs';

script.render = render;
script.__file = "packages/components/form/src/form.vue";
//# sourceMappingURL=form.mjs.map
